import { useQuery } from "@tanstack/react-query";
import { apiClient } from "~/services/api.service";
import { endpointsPublic } from "~/services/endpoint";

/**
 * @param {string} documentId 
 */
export const useSystemDetail = (documentId?: string) => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [endpointsPublic.detail_system, documentId],
    enabled: !!documentId, 
    queryFn: async () => {
      const params = {
        populate: [
          "banners.image",
          "features.image",
          "quote.image",
          "benifits.icon",
          "prices",
          "caseStudies",
        ],
      };

      return apiClient.get(
        `${endpointsPublic.detail_system}/${documentId}`,
         params 
      );
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  return {
    data: data?.data,
    isLoading,
    isError,
    refetch,
  };
};
